import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message} from "antd";
import {AUTH_TOKEN} from "../../constants/AuthConstant";
import Cookies from "js-cookie";
import sppdProyekService from "../../services/sppdProyekService";
import tunjanganLainService from "../../services/tunjanganLainService";

export const initialState = {
    loading_sppd_proyek: false,
    data_sppd_proyek: [],
    data_import: [],
    showMessage:false,
    message:'',
}


export const getDataSppdProyek = createAsyncThunk('sppd_proyek/data',async (data, { rejectWithValue }) => {
    try {
        const response = await sppdProyekService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getaDataImport = createAsyncThunk('sppd_proyek/dataimport',async (data, { rejectWithValue }) => {
    try {
        const response = await sppdProyekService.data_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const emptyDataImport = createAsyncThunk('sppd_proyek/emptyimport',async (data, { rejectWithValue }) => {
    try {
        const response = await sppdProyekService.empty_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const saveDataImport = createAsyncThunk('sppd_proyek/saveimport',async (data, { rejectWithValue }) => {
    try {
        const response = await sppdProyekService.save_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})


export const sppdProyekSlice = createSlice({
    name: 'sppd_proyek',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_sppd_proyek = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataSppdProyek.fulfilled, (state, action) => {
                state.loading_sppd_proyek = false
                state.data_sppd_proyek = action.payload??[]
            })
            .addCase(getDataSppdProyek.pending, (state) => {
                state.loading_sppd_proyek = true
            })
            .addCase(getDataSppdProyek.rejected, (state, action) => {
                state.loading_sppd_proyek = false
                state.data_sppd_proyek = action.payload
            })
            .addCase(getaDataImport.fulfilled, (state, action) => {
                state.loading_sppd_proyek = false
                state.data_import = action.payload??[]
            })
            .addCase(getaDataImport.pending, (state) => {
                state.loading_sppd_proyek = true
            })
            .addCase(getaDataImport.rejected, (state, action) => {
                state.loading_sppd_proyek = false
                state.data_import = action.payload
            })

    },
})

export const {
    showLoading,
} = sppdProyekSlice.actions

export default sppdProyekSlice.reducer
